export default function (nga, admin, menu, _ename, _epretty) {
    
    
    var _entity = nga.entity(_ename);
    
    _entity.listView()
        .title(_epretty)
        .fields([
            nga.field('id').label('ID'),
            nga.field('code').label('Code').isDetailLink(true),
            nga.field('name').label('Name').isDetailLink(true)
        ])
        .sortField('name')
        .sortDir('asc')
        .listActions(['edit']);

    _entity.editionView()
        .title('Edit ' + _epretty)
        .fields([
            nga.field('name').label('Name')
        ]);
        
    _entity.creationView()
        .title('Create new ' + _epretty)
        .fields([
            nga.field('code').label('Code'),
            nga.field('name').label('Name')
        ]);

    admin.addEntity(_entity);
    
    menu.addChild(nga.menu(_entity).title(_epretty));
    
    return _entity;
}



// WEBPACK FOOTER //
// ./js/_prototypes/setup.js